import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteUserQuery } from "../../services/apiSchedule";

export function useDeleteScheduleQuery() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteUserQuery,
    onSuccess: () => {
      toast.success("Query deleted successfully!");
      queryClient.invalidateQueries(["userQueries"]);
    },
    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
      else toast.error(e.message);
    },
  });
}
